



































import {computed, defineComponent, ref} from "@vue/composition-api";
import useFormHelper from "@tool/Helpers/useFormHelper";
import useVuelidate from "@vuelidate/core";
import {helpers, minLength, required, sameAs} from "@vuelidate/validators";
import FormSection from "@tool/Components/FormSection.vue";
import FormError from "@tool/Components/FormError.vue";
import InputErrors from "@tool/Components/InputErrors.vue";
import {useToast} from "vue-toastification/composition";
import useAxios from "@tool/Helpers/useAxios";

export default defineComponent({
    components: {
        FormSection,
        FormError,
        InputErrors,
    },

    setup() {

        const refPassword = ref<HTMLInputElement | null>(null);
        const refCurrentPassword = ref<HTMLInputElement | null>(null);

        const form = useFormHelper({
            current_password: '',
            password: '',
            password_confirmation: '',
        }, {
            current_password: 'Current Password',
            password: 'New Password',
            password_confirmation: 'Confirm Password',
        }, {
            keepProcessingOnSuccess: false
        });

        const rules = computed(() => ({
            current_password: {
                required
            },
            password: {
                required,
                minLength: helpers.withMessage('Password should be at least 8 characters long', minLength(8))
            },
            password_confirmation: {
                required,
                sameAsPassword: sameAs(form.value.data.password, 'New Password')
            }
        }));

        const formValidator = useVuelidate(rules, form.value.data);

        const toast = useToast();

        const formHandle = () => {
            form.value.submit((data) => {
                return useAxios().put<{
                    success: true
                }>(route('app.settings.profile.update-password'), {
                    current_password: data.current_password,
                    password: data.password,
                    password_confirmation: data.password_confirmation,
                });
            }).then(response => {
                if (response.success) {
                    form.value.reset();
                    // @ts-ignore
                    formValidator.value.$reset();
                    toast.success('Your password was successfully updated!');
                } else {
                    if(form.value.error && form.value.error.errors) {
                        if (form.value.error.errors.password) {
                            form.value.reset('password', 'password_confirmation')
                            refPassword.value!.focus()
                        }

                        if (form.value.error.errors.current_password) {
                            form.value.reset('current_password')
                            refCurrentPassword.value!.focus();
                        }
                    }

                }
            })
        };


        return {
            form,
            formValidator,
            formHandle,
            refPassword, refCurrentPassword
        }
    },

});
